import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';

// eslint-disable-next-line require-await
export default [
  {
    // Manage firm:
    path: '/advisor/firm-profile/:sectionId?/',
    name: 'ManageFirm',
    component: () => import('@advisor/components/settings/manageFirm/ManageFirm'),
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Firm Profile',
        componentId: COMPONENT_ID.SETTINGS_MANAGE_RIA,
      },
      riaComponent: RIA_COMPONENT.SETTINGS_MANAGE_RIA,
      platformArea: PLATFORM_AREA.SETTINGS_MANAGE_RIA,
      visibilityComponentId: COMPONENT_ID.SETTINGS_MANAGE_RIA,
    },
  },
];
